var React = require('react');
var Frame = require('../../views/Frame');

var createSprite = require('../../../lib/createSprite');
var Utils = require('../../../lib/utils');

var EndFrame = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object
    },

    contextTypes: {
        language: React.PropTypes.string,
    },

    sprites: null,
    appearTimeline: null,

    getDefaultProps: function()
    {
        return {
            storySubtitle: '',
            backgroundKey: 'endFrameBg',
            className: 'end-frame',
            titleObj: {
                scale: {
                    x: '34%'
                },
                position: {
                    x: '50%',
                    y: '20.8%'
                },
                anchor: {
                    x: 0.5,
                    y: 0.5
                }
            }
        }
    },

    render: function()
    {
        var texts = [
            {
                title: '', //  '− '+this.props.storySubtitle+' −',
                subtitle: null,
                opts: {
                    align: 'center',
                    y: 642,
                    titleStyle: {
                        fontSize: '40px',
                        fontFamily: 'Oswald',
                        lineHeight: 40
                    }
                }
            }
        ];

        return (
            <Frame
                texts={texts}
                animateTexts={false}
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                { ...this.props }
            />
        );
    },

    build: function(container, timeline, opts)
    {
        this.sprites = {
            container: container
        };

        this.timeline = timeline;

        this.buildObjects();
    },

    play: function()
    {

    },

    pause: function()
    {

    },

    destroy: function()
    {
        if (this.appearTimeline) {
            this.appearTimeline.kill();
            this.appearTimeline = null;
        }

        if (this.timeline) {
            this.timeline.kill();
            this.timeline = null;
        }

        if (this.sprites) {
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }
        this.sprites = null;
        this.sprites = null;

    },

    buildObjects: function()
    {
        // var context = this.context;
        // var props = this.props;
        // var sprites = this.sprites;
        // var objs = props.objs;
        // var container = sprites.container;
        //
        // var language = context.language;
        // var lang = language === 'en' ? '' : 'Fr';
        // // title
        // var titleObject = objs[props.titleObjectKey+lang];
        // var title = sprites.title = createSprite(titleObject);
        // Utils.setSizeAndPositionFromRefSize(title, props.width, props.height, props.titleObj);
        // //title.alpha = 0;
        //
        // // summary
        // var summaryObject = objs.endFrameSummary;
        // var summary = sprites.summary = createSprite(summaryObject);
        // Utils.setSizeAndPositionFromRefSize(summary, props.width, props.height, summaryObject);
        // summary.alpha = 0;
        //
        // container.addChild(title);
        // container.addChild(summary);
    },

    onFocus: function(duration)
    {
        /*duration = typeof duration !== 'undefined' ? duration:0.4;

        var sprites = this.sprites;
        if (this.appearTimeline)
        {
            this.appearTimeline.kill();
        }
        var appearTimeline = this.appearTimeline = new TimelineMax();

        appearTimeline.to(sprites.title, duration, {
            alpha: 1
        }, 0.2);

        appearTimeline.to(sprites.summary, duration, {
            alpha: 1
        }, '+=0.4');*/
    },

    onBlur: function(duration)
    {
        /*duration = typeof duration !== 'undefined' ? duration:0.4;

        var sprites = this.sprites;
        if (this.appearTimeline)
        {
            this.appearTimeline.kill();
        }
        var appearTimeline = this.appearTimeline = new TimelineMax();

        appearTimeline.to([sprites.title, sprites.summary], duration, {
            alpha: 0
        });*/
    }

});

module.exports = EndFrame;



// WEBPACK FOOTER //
// ./js/components/frames/_common/EndFrame.jsx